<template>
  <spinner-container :loading="localLoading">
    <back-btn />

    <v-row justify="center">
      <v-col cols="12" md="8">
        <Form :member="member" @emitDaData="update" />
      </v-col>
    </v-row>
  </spinner-container>
</template>

<script>
import Form from "@/components/member/Form";
import { mapState } from "vuex";
import SpinnerContainer from "@/components/container/SpinnerContainer";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    Form,
    SpinnerContainer,
    BackBtn,
  },
  data: () => ({}),
  computed: {
    ...mapState("Member", ["member"]),
    ...mapState("Loading", ["localLoading"]),
  },
  methods: {
    update(payload) {
      this.$store.dispatch("Member/update", payload).then(() => {
        this.$router.push("/member");
      });
    },
  },
  created() {
    this.$store.dispatch("Loading/changeLocalLoading");
    this.$store.dispatch("Member/getEach", this.$route.params.id).then(() => {
      this.$store.dispatch("Loading/changeLocalLoading");
    });
  },
};
</script>
